// extracted by mini-css-extract-plugin
module.exports = {"BundlesCommon":"TabBundles_BundlesCommon__0xu9b","BundlesCommon3":"TabBundles_BundlesCommon3__n2yfw"};